import './FormContent.css';
import React, { useRef } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

import es from '../../lang/es';
import alertMessages from '../../helpers/alertMessages';
import { listProceedingsAction } from '../../actions/proceedingActions';
import { useState } from 'react';
import ProceedingList from '../Proceeding/ProceedingList';
import ReCAPTCHA from 'react-google-recaptcha';

const FormContent = ({ jurisdiction, setLoading }) => {
    const dispatch = useDispatch();
    const recaptchaRef = useRef();

    const proceedings = useSelector( state => state.proceeding.proceedings);
    const searchParams = useSelector( state => state.proceeding.searchParams );

    const initPage = 1;    

    const initFilter = {
        jurisdiction: jurisdiction ? jurisdiction.id : '',
        page: initPage,
        unit: '',
        number: '',
        actor: '',
        accused: ''
    }

    const [ filter, setFilter ] = useState(searchParams ? searchParams : initFilter);

    //Función que carga los pagos
    const searchProceedings = async page => {
        setLoading(true);

        try {
            const captcha = await recaptchaRef.current.executeAsync();

            //Actualizo la página
            const newFilter = {
                ...filter,
                jurisdiction: filter.jurisdiction ? filter.jurisdiction : jurisdiction.id,
                page,
                captcha
            }
            //Guardo los filtros
            setFilter(newFilter);

            //Verifico que el token esté 
            if(captcha === null || captcha.trim() === ''){
                setLoading(false);
                alertMessages.error(es.ERROR.CAPTCHA);
                setTimeout(() => {
                    window.location.reload();
                }, [1000]);
                return false;
            }

            dispatch( listProceedingsAction(newFilter) );
            setLoading(false);
        } catch (error) {
            console.log(error);
            setLoading(false);
        }
    }

    //Función para cargar más registros
    const handleLoadMore = e  => {
        e.preventDefault();
        //Seteo el nuevo valor de página
        const newPage = filter.page + 1;
        //Ejecuto la búsqueda
        searchProceedings(newPage);
    }

    //Manejo los cambios
    const handleChange = e => {
        setFilter({
            ...filter,
            [e.target.name]: e.target.value
        })
    }
    
    const handleSearch = async e => {
        e.preventDefault();
        searchProceedings(1);
    }

    return (
        <>
        <Col xs={12}>
            <form onSubmit={handleSearch} autoComplete="off">
                <Row>
                    <Form.Group className="col-md-2">
                        <Form.Label>{ es.FIELDS.EXPTE }</Form.Label>
                        <Form.Control
                            type="text"
                            name="number"
                            autoFocus
                            placeholder="Ej: 1/20"
                            onChange={handleChange}
                            value={filter.number}
                        />
                    </Form.Group>
                    <Form.Group className="col-md-5">
                        <Form.Label>{ es.FIELDS.ACTOR }</Form.Label>
                        <Form.Control
                            type="text"
                            name="actor"
                            placeholder="Ej: Perez"
                            onChange={handleChange}
                            value={filter.actor}
                        />
                    </Form.Group>
                    <Form.Group className="col-md-5">
                        <Form.Label>{ es.FIELDS.ACCUSED }</Form.Label>
                        <Form.Control
                            type="text"
                            name="accused"
                            placeholder="Ej: Lopez"
                            onChange={handleChange}
                            value={filter.accused}
                        />
                    </Form.Group>
                    <Form.Group className="col-md-6">
                        <Form.Label>{ es.FIELDS.UNIT }</Form.Label>
                        <Form.Control
                            as="select"
                            name="unit"
                            onChange={handleChange}
                            value={filter.unit}
                        >
                            <option value="">Todas las Unidades Judiciales</option>
                            {
                                jurisdiction && jurisdiction.units ? (
                                    jurisdiction.units.map(unit => (
                                        <option value={ unit.saeid } key={`u${unit.id}`}>
                                            { unit.description }
                                        </option>
                                    ))
                                ) : null
                            }
                        </Form.Control>
                    </Form.Group>
                    <Form.Group className="col-md-1">
                        <Form.Label>&nbsp;</Form.Label>
                        <Button variant="primary" type="submit" block>
                            <FontAwesomeIcon icon={ faSearch } />
                        </Button>
                    </Form.Group>
                    
                    <ReCAPTCHA
                        badge="bottomright"
                        size="invisible"
                        ref={recaptchaRef}
                        sitekey={ process.env.REACT_APP_RECAPTCHA_KEY }
                    />
                </Row>
            </form>
        </Col>
        {
            proceedings ? (
                <ProceedingList
                    initPage={initPage}
                    filter={filter}
                    proceedings={proceedings}
                    handleLoadMore={handleLoadMore}
                />
            ) : null
        }
        </>
    );
};

export default FormContent;